module.exports = {"id":"212018","name":"Koo Ja Ryong","rating":"73","photo":"./data/images/photos/2/212018.png","club":{"name":"Suwon Bluewings","logo":"./data/images/clubs/SuwonBluewings.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KooJaRyong0.json
// module id = 2404
// module chunks = 0